import React from 'react';
import { useAppSelector } from '../app/hooks';
import { useAppDispatch } from '../app/store';
import { setLayoutSetting } from '../features/calendar/calendar-slice';

export const ViewToggle = () => {
	const layoutSetting = useAppSelector(state => state.calendar.layoutSetting);
	const dispatch = useAppDispatch();
	const { gridViewModeButtonText, listViewModeButtonText } = useAppSelector(state => state.settings);

	return (
		<div className="ace-cal-view spaced-list">
			<div>
				<input id="calendarViewMini" className="radio-btn" type="radio" name="calendarView" checked={layoutSetting == 'A'} onChange={(e) => {
					const target = (e.target as HTMLInputElement);
					if (target.checked)
						dispatch(setLayoutSetting('A'))
				}} />
				<label htmlFor="calendarViewMini">Mini Calendar</label>
			</div>
			{
				listViewModeButtonText &&
				<div>
					<input id="calendarViewList" className="radio-btn" type="radio" name="calendarView" checked={layoutSetting == 'B'} onChange={(e) => {
						const target = (e.target as HTMLInputElement);
						if (target.checked) {
							dispatch(setLayoutSetting('B'))
						}
					}} />
					<label htmlFor="calendarViewList">{listViewModeButtonText}</label>
				</div>
			}
			{
				gridViewModeButtonText &&
				<div>
					<input id="calendarViewGrid" className="radio-btn" type="radio" name="calendarView" checked={layoutSetting == 'C'} onChange={(e) => {
						const target = (e.target as HTMLInputElement);
						if (target.checked) {
							dispatch(setLayoutSetting('C'))
						}
					}} />
					<label htmlFor="calendarViewGrid">{gridViewModeButtonText}</label>
				</div>
			}
		</div>
	)

}